// extracted by mini-css-extract-plugin
export default {"panel":"CommitGroup-module__panel__b_sg9Ag"};